export class EquipmentActivity  {
    ID?: number;
    Name?: string;
}

export default EquipmentActivity;